import React, { Component } from 'react';
import SelectableList from '../portal/selectableList';
import { Popover, OverlayTrigger } from 'react-bootstrap';

export default class UsersGridFilter extends Component {

    constructor(props) {
        super(props);
        this.buttonRef = `${props.filterId}-button`;
        this.listRef = `${props.filterId}-list`;
        this.state = { isFilterOpen: false };
    }
    
    handleGridFilter = (selectedItemIds) => {
        
        this.filterGrid(selectedItemIds);
        this.props.afterGridFiltering(selectedItemIds);
        this.hideFilter();
    }
    
    filterGrid = (selectedItemIds) => {
         
        if(selectedItemIds.length > 0){
            this.currentSelectedItemIds = selectedItemIds;
            this.props.handleFilter({ callback: this.isAnyItemSelected });
        }
        else{
            this.props.handleFilter();
        }
    }

    isAnyItemSelected = (itemIds) => {
        let _this = this;
        var isItemSelected = false;
        
        itemIds.forEach(function (itemId) {
            
            if(_this.isSelectedItemsInclude(itemId))
            {
                isItemSelected = true;
            }
        });

        return isItemSelected;
    }

    isSelectedItemsInclude = (itemId) => {
         for (var i = 0; i < this.currentSelectedItemIds.length; i++) {
            if (this.currentSelectedItemIds[i] === itemId) {
                return true;
            }
        }
        
        return false;
    }

    hideFilter = () => {
        this.refs.filterOveray.hide();
    }

    isFilterActive = () => {
        return this.props.gridFiltered || this.state.isFilterOpen;
    }

    setFilterOpen = () => {
        
        this.setFilterVisibility(true) ;
    }

    setFilterClose = () => {
        
        this.setFilterVisibility(false) ;
    }

    setFilterVisibility = (isOpen) => {
        
        this.setState({ isFilterOpen: isOpen }) ;
    }

    render() {

        const userGridFilterPopover = (
            <Popover id='popover-user-grid-filter' className='user-grid-filter'>
                <SelectableList 
                    ref={ this.listRef }
                    headerTitle={this.props.header} 
                    handleSaveSelectedItems = {this.handleGridFilter}
                    data={this.props.data}
                    selectedItemIds={this.props.selectedItemIds}
                    searchPlaceHolderTitle={this.props.searchPlaceHolderTitle}
                    formatAdditionalData={this.props.formatAdditionalData}
                    submitLabel={this.props.submitLabel}
                    onOpen={this.setFilterOpen}
                    onClose={this.setFilterClose}
                    rowHeight={this.props.rowHeight}
                    height={this.props.height}
                    hideSearch={this.props.hideSearch}>
                </SelectableList>
            </Popover>
        );
        
        return (
            <OverlayTrigger
                ref='filterOveray'
                trigger='click'
                rootClose
                placement='bottom'
                overlay={userGridFilterPopover}>
                <div className='user-grid-filter'>
                    <span 
                        ref={ this.buttonRef } 
                        data-cy={this.props.dataCy} 
                        className={ ( this.isFilterActive() ? 'active-' : '') + 'filter-icon'}>
                    </span>
                </div>
            </OverlayTrigger>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/users/usersGridFilter.jsx